// @ts-nocheck
// Reads the logged-in user's ACL `module_operations` and re-reads it on the
// `acl-refreshed` window event. Shared by every /cti2 surface that gates on
// MODULE_ACL, so the parse/refresh logic lives in one place.
import { useEffect, useState } from 'react';
import { getUser } from '@/utilities/setting';
import { USER_ROLES } from '@/utilities/constant';
import { refreshSession } from '@/utilities/sessionRefresh';

export function useModuleOps() {
  const [moduleOps, setModuleOps] = useState({});
  useEffect(() => {
    const apply = () => {
      const ops = getUser()?.acl_settings?.module_operations;
      if (!ops) return;
      try {
        setModuleOps(typeof ops === 'string' ? JSON.parse(ops) : ops);
      } catch {
        /* keep last-known ops */
      }
    };
    apply();
    window.addEventListener('acl-refreshed', apply);
    // AppShell.tsx only calls refreshSession() once, on its own mount — an
    // admin granting an agent a new module afterward never reaches this tab
    // until a hard reload/relogin, since navigating to /cti2 doesn't remount
    // AppShell. Refreshing here too means landing on /cti2 (or reopening a
    // dashboard section that reads this) always picks up the latest grants;
    // refreshSession() dedupes concurrent calls, so every consumer of this
    // hook mounting at once still only fires one request.
    refreshSession();
    return () => window.removeEventListener('acl-refreshed', apply);
  }, []);
  return moduleOps;
}

export function useIsSuperAdmin() {
  return getUser()?.role === USER_ROLES.SUPERADMIN;
}

export default useModuleOps;
